import { Component, Input, OnInit } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import * as SecureLS from "secure-ls";
import { ExcelServiceService } from "src/app/excel-service.service";
import { GlobalService } from "src/app/services/global.service";

@Component({
  selector: "app-top-ten-student-viewedlist",
  templateUrl: "./top-ten-student-viewedlist.component.html",
  styleUrls: ["./top-ten-student-viewedlist.component.css"],
})
export class TopTenStudentViewedlistComponent implements OnInit {
  @Input() roleId: number;
  private ls = new SecureLS({ encodingType: "aes" });
  videolist: any = [];
  total_count: any = 0;
  recrange: any;
  constructor(
    public globalService: GlobalService,
    private spinner: NgxSpinnerService,
    private excelservice: ExcelServiceService
  ) {}

  ngOnInit(): void {
    this.getstudentviewedlist(false);
  }

  async getstudentviewedlist(isExcelExport) {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
    };
    let studentviewedlist = await this.globalService.get(
      "videolog/best/student",
      filter,
      true
    );
    this.spinner.hide();
    this.videolist = studentviewedlist["content"];
    this.total_count = studentviewedlist["content"]?.length;
    if (isExcelExport) this.excelExport(studentviewedlist);
  }

  exportAsXLSX() {
    this.getstudentviewedlist(true);
  }

  excelExport(uivideoList) {
    let uivideos = uivideoList['content'].map((item: any, i) => {
      return {
        S_NO: i+1,
        NAME: `${item.student_details.first_name} ${item.student_details.last_name}`,
        DEPARTMENT: item.student_details.department.name,
        BATCH: item.student_details.batch.batch,
        DURATION: item.total_duration,
        SECTION: item.student_details.section,
      };
    });

    this.excelservice.exportAsExcelFile(uivideos, "Top Ten Student Record");
  }
}
